import React, { useState } from 'react';

import Parser from 'html-react-parser';

import { storageHandler } from "./storage"
import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET_KEY;


const calSubTotal = (getcartItem) => {
  let subtotalVal = 0;
  getcartItem.length > 0 &&
    getcartItem.map(item => {
      if (item.tama_payment === 1) {
        subtotalVal = Number(subtotalVal) + (Number(item.price))
      }
    })

  return subtotalVal;
}

const calDeductionFromavailableBalance = (subtotalVal, availableBalance) => {
  return subtotalVal > availableBalance ? availableBalance : subtotalVal;
}
const calTotalToPay = (subtotalVal, deductedFromAvailableBalance) => {
  return Number(subtotalVal) - Number(deductedFromAvailableBalance);
}
const decryptData = (cipherText, secretKey) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};
const getCartItemInArray = (userId) => {
  let decryptedData = storageHandler.getCartItem();
  if (decryptedData !== null) {
    const storedCartItem = decryptData(decryptedData, secretKey);
    let getcartItem = [];
    let getcartItem_base = storedCartItem.length > 0 && JSON.parse(storedCartItem);

    return getcartItem = getcartItem_base.filter(item => item.cart_item_addedBy === userId);
  } else {
    return [];
  }
}
const getCartafterRemovingItemInArray = (userId) => {
  let decryptedData = storageHandler.getCartItem();
  if (decryptedData !== null) {
    const storedCartItem = decryptData(decryptedData, secretKey);
    let getcartItem = [];
    let getcartItem_base = storedCartItem.length > 0 && JSON.parse(storedCartItem);

    return getcartItem = getcartItem_base.filter(item => item.cart_item_addedBy !== userId);
  } else {
    return [];
  }
}
export const cartutils = { getCartafterRemovingItemInArray, calSubTotal, calDeductionFromavailableBalance, calTotalToPay, getCartItemInArray };

